const AZZIR_HOSTS = new Set(["azzirevents.com", "www.azzirevents.com"]);

function decodeHtmlEntities(value) {
  return String(value || "")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim();
}

/** Google Docs export wraps links in google.com/url?q=... */
export function unwrapGoogleRedirect(url) {
  const decoded = decodeHtmlEntities(url);
  if (!decoded) return decoded;

  try {
    const parsed = new URL(decoded);
    if (
      (parsed.hostname === "www.google.com" ||
        parsed.hostname === "google.com") &&
      parsed.pathname === "/url"
    ) {
      const target =
        parsed.searchParams.get("q") || parsed.searchParams.get("url");
      if (target) return decodeURIComponent(target);
    }
  } catch {
    // keep original
  }

  return decoded;
}

export function toInternalPath(url) {
  const resolved = unwrapGoogleRedirect(url);
  if (!resolved) return resolved;

  try {
    const parsed = new URL(resolved, "https://azzirevents.com");
    if (!AZZIR_HOSTS.has(parsed.hostname)) {
      return resolved;
    }

    const path = parsed.pathname.replace(/\/+$/, "") || "/";
    const suffix = `${parsed.search}${parsed.hash}`;
    return `${path}${suffix}`;
  } catch {
    return resolved;
  }
}

function isInternalPath(path) {
  return (
    typeof path === "string" && path.startsWith("/") && !path.startsWith("//")
  );
}

function stripAttr(attrs, name) {
  const pattern = new RegExp(`\\s${name}\\s*=\\s*(["'])[^"']*\\1`, "gi");
  return String(attrs || "").replace(pattern, "");
}

function normalizeAnchorTag(_match, attrs) {
  const hrefMatch = attrs.match(/\bhref=(["'])(.*?)\1/i);
  if (!hrefMatch) return `<a${attrs}>`;

  const [, quote, href] = hrefMatch;
  const internalPath = toInternalPath(href);
  const externalPath = unwrapGoogleRedirect(href);
  const useInternal = isInternalPath(internalPath);

  let nextAttrs = attrs.replace(/\bhref=(["'])(.*?)\1/i, "");
  nextAttrs = stripAttr(nextAttrs, "target");
  nextAttrs = stripAttr(nextAttrs, "rel");

  const destination = useInternal ? internalPath : externalPath;
  const targetAttr = useInternal ? "" : ' target="_blank"';
  const relAttr = useInternal ? "" : ' rel="noopener noreferrer"';

  return `<a${nextAttrs} href=${quote}${destination}${quote}${targetAttr}${relAttr}>`;
}

/** Clean CMS HTML: unwrap Google redirect links and map Azzir URLs to in-app paths. */
export function processBlogHtml(html) {
  if (!html || typeof html !== "string") return html;

  return html.replace(/<a\b([^>]*)>/gi, normalizeAnchorTag);
}
